module.exports = __webpack_public_path__ + "img/flsxw.ef7a1af7.jpg";